module.exports = __webpack_public_path__ + "img/OTO_XE_MAY_XE_DAP.db79eadb.svg";